module.exports = __webpack_public_path__ + "img/logo.384697bc.svg";